(function($) {
  let previewCount = 0;

  function initializeTablePreviews(root) {
    $(root).find('.product-description-block').each(function() {
      const shortDescription = $(this).children('.short-one, .short-three')[0];
      const fullDescription = $(this).children('.product-description-full')[0];

      if (!shortDescription || !fullDescription || shortDescription.dataset.tablePreviewReady) {
        return;
      }

      const tables = fullDescription.querySelectorAll('table');
      const readMoreLink = shortDescription.querySelector('.readmore');

      if (tables.length !== 1 || !readMoreLink) {
        return;
      }

      const remainingContent = fullDescription.cloneNode(true);
      remainingContent.querySelector('table').remove();
      remainingContent.querySelectorAll('.readless').forEach(element => element.remove());

      if (remainingContent.textContent.trim() || tables[0].querySelector('input, select, textarea, button, iframe, script, style')) {
        return;
      }

      const previewTable = tables[0].cloneNode(true);
      const hasMoreRows = previewTable.rows.length > 2;
      Array.from(previewTable.rows).slice(2).forEach(row => row.remove());
      Array.from(previewTable.rows).forEach((row, rowIndex) => {
        Array.from(row.cells).forEach(cell => {
          if (cell.rowSpan === 0 || cell.rowSpan > 2 - rowIndex) {
            cell.rowSpan = 2 - rowIndex;
          }
        });
      });

      const previewIds = new Map();
      const previewPrefix = 'description-preview-' + (++previewCount) + '-';
      [previewTable, ...previewTable.querySelectorAll('[id]')].forEach(element => {
        if (element.id) {
          previewIds.set(element.id, previewPrefix + element.id);
          element.id = previewIds.get(element.id);
        }
      });
      previewTable.querySelectorAll('[headers], [aria-labelledby], [aria-describedby]').forEach(element => {
        ['headers', 'aria-labelledby', 'aria-describedby'].forEach(attribute => {
          if (element.hasAttribute(attribute)) {
            element.setAttribute(attribute, element.getAttribute(attribute).split(/\s+/).map(reference => previewIds.get(reference) || reference).join(' '));
          }
        });
      });

      shortDescription.replaceChildren(previewTable);
      if (hasMoreRows) {
        shortDescription.appendChild(readMoreLink);
      }
      shortDescription.dataset.tablePreviewReady = 'true';
    });
  }

  function ReadMore() {
    $(document).on('click', '.readmore', function(e) {
      e.preventDefault();

      const descriptionBlock = $(this).closest('.product-description-block');
      descriptionBlock.children('.product-description-short').addClass('hide');
      descriptionBlock.children('.product-description-full').removeAttr('hidden').removeClass('hide');
    });
    
    $(document).on('click', '.readless', function(e) {
      e.preventDefault();

      const descriptionBlock = $(this).closest('.product-description-block');
      descriptionBlock.children('.product-description-short').removeClass('hide');
      descriptionBlock.children('.product-description-full').attr('hidden', true).addClass('hide');
    });    
  }
  
  $(document).ready(function() {
    initializeTablePreviews(document);
    ReadMore();
  });

  $(document).on('shopify:section:load', function(event) {
    initializeTablePreviews(event.target);
  });
})(jQuery);
